import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Liberty from "@/pages/Liberty";

export const Route = createFileRoute("/pl/liberty")({
  head: () => routeHead('AGAPE Liberty — Treści i widoczność w AI', META_DESCRIPTIONS.liberty.pl, '/pl/liberty'),
  component: Liberty,
});
